var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWsp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 351.22 157.93",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5592ac;}.cls-2{fill:#89c6b5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2-2",
    "data-name": "Calque 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.53,100.73v57.2h5.74V104.36A50.42,50.42,0,0,1,274.53,100.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.45,62v95.74h5.74V84.12A49.36,49.36,0,0,1,254.45,62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.7 48.78 116 108.2 116 97.44 83.7 38.1 83.7 48.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.7 1.58 83.7 12.21 116 71.63 116 60.93 83.7 1.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.88 59.28 26.32 1.3 20.54 1.3 57.88 69.99 57.88 59.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.88 97.01 5.78 1.3 0 1.3 57.88 107.77 57.88 97.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116 1.3 116 108.76 141.82 108.76 141.82 1.3 116 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.53,40.18H185.3v-14h43.31V1.3H160.9V40.48a24.68,24.68,0,0,0,24.68,24.68h.07l24.89-.08c4.7,0,9.47,4.76,9.47,9.46S215.24,84,210.54,84H160.89v24.9h49.64a34.37,34.37,0,1,0,1.17-68.73q-.58,0-1.17,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.88 1.3 57.88 108.76 83.7 108.76 83.7 1.3 57.88 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.83,0c-26.68,0-48.39,22-48.39,49.12v11.8C254.44,88,276.15,110,302.83,110s48.39-22,48.39-49.11V49.12C351.21,22,329.51,0,302.83,0Zm24.05,60.91c0,13.66-10.79,24.78-24.05,24.78s-24.05-11.12-24.05-24.78V49.11c0-13.66,10.79-24.78,24.05-24.78s24.05,11.12,24.05,24.78Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWsp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WSP.17e92d614dedc37f9cdfe14094439c33.svg";